import React, { FC } from 'react'
import * as StyledHero from './standardHero.styles'
import { PrismicImage } from 'interfaces/prismic/fields/fields'
import { RichTextBlock } from 'prismic-reactjs'
// @ts-ignore
import { RichText } from 'prismic-reactjs'

interface Props {
	title?: string | RichTextBlock[]
	image: string | PrismicImage
	short?: boolean
	desktopOnly?: boolean
	imageOnMobile?: boolean
	showHeroTitle?: boolean
}

const StandardHero: FC<Props> = ({ title, image, short, desktopOnly, imageOnMobile, showHeroTitle = true }) => {
	const titleValue: string = !title ? '' : typeof title === 'string' ? title : RichText.asText(title)

	if (typeof image === 'string') {
		return (
			<StyledHero.Wrapper desktopOnly={desktopOnly} short={short}>
				<StyledHero.StandardImage imageUrl={image} imageOnMobile={imageOnMobile} />
				{showHeroTitle && titleValue && <StyledHero.HeroTitle>{titleValue}</StyledHero.HeroTitle>}
			</StyledHero.Wrapper>
		)
	}
	return (
		<StyledHero.Wrapper desktopOnly={desktopOnly} short={short}>
			<StyledHero.PrismicImage imageOnMobile={imageOnMobile} image={image} />
			{showHeroTitle && titleValue && <StyledHero.HeroTitle>{titleValue}</StyledHero.HeroTitle>}
		</StyledHero.Wrapper>
	)
}

export default StandardHero
